import ACTION from '../action_constant';
import API from '../api_config';
import $ from 'jquery';

const fileUploadActions = {

  shipmentImageUpload: function(imageFileObj){
    let formData = new FormData();
    formData.append("file", imageFileObj);
    formData.append("json",  JSON.stringify({
				"bucketName": "awb-shipment-images"
		}));
    const promise = $.ajax({
        url : API.s3bucketEndpoint,
        type : 'POST',
        cache: false,
				dataType: 'json',
				contentType: false,
				processData: false,
				crossDomain: true,
        data : formData,
        success : (data) => {

        },
        error : (error) => {

        },
      });
    return promise;
  },

  profileImageUpload: function(imageFileObj){
    let formData = new FormData();
    formData.append("file", imageFileObj);
    formData.append("json",  JSON.stringify({
				"bucketName": "awb-profile-images"
		}));
    const promise = $.ajax({
        url : API.s3bucketEndpoint,
        type : 'POST',
        cache: false,
				dataType: 'json',
				contentType: false,
				processData: false,
				crossDomain: true,
        data : formData,
        success : (data) => {

        },
        error : (error) => {
          
        },
      });
    return promise;
  }

}

module.exports = fileUploadActions;



// WEBPACK FOOTER //
// app/image_upload/file_upload_actions.jsx